import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-morder-cancel-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class MorderCancelEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	$("#mmypage-menu6").addClass("active");   
  }

  // 숫자증가
  qty_plus(event) {
  
    var that = $(event.target);
    var findrowA  = that.closest("i");    //  클릭한 행의 i
    
    $(".orders>.footer>.qty").removeClass("active");
    findrowA.parent().addClass("active");
        
    let tmp: any = $(".active .count").val();
    $(".active>.count").val(parseInt( tmp ) + 1 );
  }

  // 숫자감소
  qty_minus(event) {
  
    var that = $(event.target);
    var findrowA  = that.closest("i");    //  클릭한 행의 i
    
    $(".orders>.footer>.qty").removeClass("active");
    findrowA.parent().addClass("active");
    
    let tmp: any = $(".active .count").val();

    $(".active .count").val(parseInt(tmp) - 1 );
    if ($(".active .count").val() == 0) {
        $(".active .count").val(1);
    }
  }

}
